<!-- Delete Document-->
<ui-dialog
    [open]="isDeleteAttachmentDialogOpen"
    (closing)="closeDeleteAttachmentDialog()"
    header="{{ 'applicant-tracker.applicants.deleteDocument' | appTranslate }}"
>
    <p>{{ 'applicant-tracker.applicants.areYouSureYouWantToDeleteThisDocument' | appTranslate }}</p>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="closeDeleteAttachmentDialog()">{{ 'cancel' | appTranslate }}</ui-button>
        <ui-button type="danger" (click)="onDelete()">{{ 'delete' | appTranslate }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<!-- Rename Document-->
<ui-dialog
    [open]="isRenameAttachmentDialogOpen"
    (closing)="closeRenameAttachmentDialog()"
    header="{{ 'applicant-tracker.applicants.renameDocument' | appTranslate }}"
>
    <form #form="ngForm" autocomplete="off">
        <div class="app-grid">
            <mat-form-field class="columns-12">
                <mat-label>{{ 'applicant-tracker.applicants.documentDisplayName' | appTranslate }}</mat-label>
                <input
                    matInput
                    type="text"
                    required
                    name="applicantDocumentDisplayName"
                    [(ngModel)]="applicantDocumentDisplayName"
                />
            </mat-form-field>
        </div>

        <ui-dialog-footer>
            <ui-button type="ghost" (click)="closeRenameAttachmentDialog(); resetSelectedDocument()">{{
                'cancel' | appTranslate
            }}</ui-button>
            <ui-button type="primary" [disabled]="!applicantDocumentDisplayName" (click)="updateApplicantDocument()">{{
                'save' | appTranslate
            }}</ui-button>
        </ui-dialog-footer>
    </form>
</ui-dialog>

<!-- Document Preview-->
<ui-dialog
    [open]="isDocumentPreviewDialogOpen"
    class="preview-dialog"
    (closing)="closeDocumentPreviewDialog()"
    [header]="
        applicantAttachmentSelected?.name ||
        applicantAttachmentSelected?.jobAttachment?.name ||
        'applicant-tracker.applicants.documentPreview'
    "
>
    <!-- Loader -->
    <div *ngIf="isDialogLoading" class="ui active inverted dimmer">
        <div class="ui loader"></div>
    </div>

    <app-pdf-viewer [static]="false" #pdfViewer></app-pdf-viewer>
    <div *ngIf="pdfError" class="pdf-error">
        <p>
            {{
                'applicant-tracker.applicants.youCanOnlyPreviewPdfFilesThisDocumentIsAApplicantAttachmentSelec'
                    | appTranslate
            }}
            <br /><br />{{ 'applicant-tracker.applicants.please' | appTranslate }}
            <a (click)="downloadFile(applicantAttachmentSelected)">{{
                'applicant-tracker.applicants.downloadTheDocument' | appTranslate
            }}</a
            >{{ 'applicant-tracker.applicants.toViewIt' | appTranslate }}
        </p>
    </div>
</ui-dialog>

<!-- Add Additional Document -->
<ui-dialog
    [open]="isAddAdditionalDocumentModalOpen"
    header="{{ 'applicant-tracker.applicants.additionalDocument' | appTranslate }}"
    (closing)="closeAddAdditionalDocumentModal()"
>
    <form #form="ngForm" autocomplete="off">
        <app-file-drop
            (filesSelected)="onDocumentSelected($event)"
            [allowedTypes]="allowedFileTypes"
            [required]="true"
            *ngIf="!applicantDocument"
        ></app-file-drop>

        <mat-label class="uploaded-document margin-bottom-2 padding-1 form-label" *ngIf="applicantDocument">
            <img appIcon="Paperclip" class="margin-right-1" />
            <span class="margin-right-1">{{ applicantDocument.name }}</span>
            <img (click)="resetSelectedDocument()" appIcon="CrossGreyUiOutline" />
        </mat-label>

        <div class="app-grid">
            <mat-form-field class="columns-12">
                <mat-label>{{ 'applicant-tracker.applicants.documentDisplayName' | appTranslate }}</mat-label>
                <input
                    matInput
                    type="text"
                    required
                    name="applicantDocumentDisplayName"
                    [(ngModel)]="applicantDocumentDisplayName"
                />
            </mat-form-field>
        </div>

        <ui-dialog-footer>
            <ui-button type="ghost" (click)="closeAddAdditionalDocumentModal(); resetSelectedDocument()">{{
                'cancel' | appTranslate
            }}</ui-button>
            <ui-button
                type="primary"
                [disabled]="!applicantDocumentDisplayName || !applicantDocument"
                (click)="saveApplicantDocument()"
                >{{ 'add' | appTranslate }}</ui-button
            >
        </ui-dialog-footer>
    </form>
</ui-dialog>

<ui-card [loading]="isLoading" [withSpacing]="false">
    <app-segment-header class="padding-x-3 padding-top-3" [title]="'applicant-tracker.applicants.allDocuments'">
        <ui-info
            [matTooltipClass]="'allow-multi-line-tooltip'"
            class="applicant-documents-tooltip"
            text="{{ 'applicant-tracker.applicants.addUpToAdditionalDocuments' }}"
        ></ui-info>
        <div class="buttons">
            <ui-button
                (click)="showAddAdditionalDocumentModal()"
                class="margin-right-2"
                [disabled]="noOfApplicantDocumentsWithoutJobAttachment >= 5"
            >
                <mat-icon svgIcon="plus"></mat-icon
                >{{ 'applicant-tracker.applicants.additionalDocument' | appTranslate }}
            </ui-button>
        </div>
    </app-segment-header>

    <app-table
        class="applicantDocumentsTable"
        [table]="applicantDocumentsIndexTable"
        [useStickyHeader]="false"
        [showSearch]="false"
        [showOffset]="false"
        [showActionsPadding]="false"
        [embedded]="true"
        (rowClicked)="onApplicantDocumentClicked($event)"
        (menuItemSelected)="menuAction($event)"
    >
        <app-empty-state
            label="{{ 'applicant-tracker.applicants.thereAreNoApplicantDocumentsForThisCandidate' }}"
            src="/assets/illustrations/empty-inbox.png"
        >
        </app-empty-state>
    </app-table>

    <div class="padding-bottom-5" *ngIf="defaultJobPostingAttachmentsNotUploaded?.length > 0">
        <ng-container *ngFor="let newApplicantAttachment of defaultJobPostingAttachmentsNotUploaded">
            <div class="app-grid padding-left-4">
                <mat-form-field class="columns-4">
                    <mat-label>{{
                        {
                            key: 'applicant-tracker.uploadJobAttachmentName',
                            params: { jobAttachmentName: newApplicantAttachment.jobAttachment?.name },
                        } | appTranslate
                    }}</mat-label>
                    <ui-mat-file-upload
                        (fileSelected)="onDefaultJobPostingAttachmentFileUpload($event, newApplicantAttachment)"
                        placeholder="{{ 'applicant-tracker.applicants.noFileAttached' | appTranslate }}"
                        [allowedTypes]="allowedFileTypes"
                    ></ui-mat-file-upload>
                    <ui-button type="outline">{{ 'applicant-tracker.applicants.browse' | appTranslate }}</ui-button>
                </mat-form-field>
            </div>
        </ng-container>
    </div>
</ui-card>
